import type { DispersalAgents } from '../types'

export const SUPABASE_URL: string = import.meta.env.VITE_SUPABASE_URL ?? ''
export const SUPABASE_ANON_KEY: string =
  import.meta.env.VITE_SUPABASE_ANON_KEY ?? ''

type DispersalAgentRecord = Record<
  DispersalAgents['id'],
  DispersalAgents['description']
>

export const PRIMARY_DISPERSAL_AGENTS: DispersalAgentRecord = {
  1: 'Animal',
  2: 'Wind',
  3: 'Water',
  4: 'Methods originating from parent plant or diaspore',
  5: 'Dispersal prevented',
  6: 'Unassisted',
  7: 'Combination: wind+unassisted',
  8: 'Combination: wind+animal',
  9: 'Combination: water+wind+animal',
  10: 'Combination: wind+water',
  11: 'Combination: animal+unassisted',
  12: 'Water?',
  13: 'Combination: wind+animal+unassisted',
  14: 'Combination: wind+water+unassisted',
  15: 'Combination: water+dispersal prevented',
  16: 'Combination: methods originating from parent plant+animal',
  17: 'Vegetative growth',
  18: 'Combination: water+animal',
  19: 'Unassisted and/or methods originating from parent plant',
}
